import { useDataValue } from 'Simple/Data.js'

export default function useDataConfiguration(props) {
  let patient_id = useDataValue({
    context: 'tab',
    path: 'patient_id',
    viewPath: props.viewPath,
  })
  let location_id = useDataValue({
    context: 'global',
    path: 'current_location._id',
    viewPath: props.viewPath,
  })
  let app_id = useDataValue({
    context: 'app_properties',
    path: 'itero_app_id',
    viewPath: props.viewPath,
  })

  return {
    variables: {
      patient_id,
      location_id,
      app_id,
    },
    requestPolicy: 'network-only',
    pause: !patient_id || !location_id,
  }
}
